import clsx from 'clsx';
import { getRange } from '../../shared/util';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as CircleFilled } from 'src/shared/components/icons/progress-circle-filled.svg';
import { ReactComponent as CircleEmpty } from 'src/shared/components/icons/progress-circle.svg';

export const Progress = ({
  value,
  max,
  className,
  circleClassName,
}: {
  value: number;
  max: number;
  className?: string;
  circleClassName?: string;
}) => {
  return (
    <div className={twMerge(clsx('flex gap-1.5 items-center', className))}>
      {getRange(max).map((i, index) => {
        return index === value ? (
          <CircleFilled key={index} className={twMerge(clsx('w-2.5 h-2.5 text-green-laser', circleClassName))} />
        ) : (
          <CircleEmpty key={index} className={twMerge(clsx('w-2.5 h-2.5 text-green-laser', circleClassName))} />
        );
      })}
    </div>
  );
};
